import { NavLink, useLocation } from "react-router-dom";

type BreadcrumbProps = {
	routes: Crumb[];
	variant: "light" | "dark";
	theme?: "bold";
};

export type Crumb = {
	label: string;
	to: string;
	isHome?: boolean;
	isActive?: boolean;
	isLast?: boolean;
};

const Breadcrumb = ({ routes, variant, theme }: BreadcrumbProps) => {
	return (
		<div className="flex items-center gap-2">
			{routes.map((item: Crumb, index: number) => (
				<BreadcrumbItem
					key={`${item.to}-${item.label}-${index}-${Math.random()}`}
					{...{ variant, theme, ...item }}
					isLast={routes?.length - 1 === index}
				/>
			))}
		</div>
	);
};

Breadcrumb.defaultProps = {
	variant: "light",
};

interface BreadcrumbItemProps extends Crumb {
	variant: "light" | "dark";
	theme?: "bold";
}

const BreadcrumbItem = ({
	label,
	to,
	isHome,
	isLast,
	variant,
	theme,
}: BreadcrumbItemProps) => {
	const location = useLocation();
	const isActive = location.pathname === to;
	let className = `flex items-center hover:text-primary transition-all gap-2`;
	if (variant === "light") {
		className += ` text-white`;
	}

	if (variant === "dark") {
		className += ` text-dark`;
	}

	if (theme === "bold") {
		className += !isActive ? ` opacity-30` : "";
		return (
			<>
				<NavLink {...{ to, className }}>
					{isHome && (
						<small className="rounded-md flex items-center justify-center">
							<i className="fas fa-home"></i>
						</small>
					)}
					<strong className={isHome ? "hidden md:block" : ""}>
						{label}
					</strong>
				</NavLink>
				{!isLast && (
					<span>
						<i className="fas fa-angle-right"></i>
					</span>
				)}
			</>
		);
	}

	return (
		<>
			<NavLink {...{ to, className }}>
				{isHome && (
					<small className="rounded-md flex items-center justify-center">
						<i className="fas fa-home"></i>
					</small>
				)}
				<span className={isHome ? "hidden md:block" : ""}>{label}</span>
			</NavLink>
			{!isLast && (
				<span>
					<i className="fal fa-angle-right"></i>
				</span>
			)}
		</>
	);
};

export default Breadcrumb;
